module.exports = __webpack_public_path__ + "img/banner_20260130105957.89505b72.png";